/* -------------------------------------------------------------------------- */
/*                                Badge styles                               */
/* -------------------------------------------------------------------------- */

@import './bq-badge.variables';

:host {
  @apply inline-block;
}

.bq-badge {
  @apply flex items-center justify-center bg-[color:--bq-badge--background-color] text-[color:--bq-badge--text-color];
  @apply rounded-[--bq-badge--border-radius] border-[length:--bq-badge--border-width] border-[color:--bq-badge--border-color];

  border-style: var(--bq-badge--border-style);
  box-shadow: var(--bq-badge--box-shadow);
}

.size {
  &--small {
    @apply bs-[--bq-badge--size-small] is-[--bq-badge--size-small];
  }

  &--medium {
    @apply bs-[--bq-badge--size-medium] is-[--bq-badge--size-medium];
  }
}

.digit {
  @apply min-bs-[--bq-badge--size-large] min-is-[--bq-badge--size-large];
}
